"use client";

import { useState, useEffect } from "react";
import { useAuth } from "@clerk/nextjs";
import { AlertTriangle, Loader2 } from "lucide-react";

import { GridContainer } from "@/components/layout/GridContainer";

export function PaymentFailedBanner() {
  const { isSignedIn } = useAuth();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isSignedIn) return;
    const check = () => {
      fetch("/api/membership")
        .then((r) => r.json())
        .then((data) => {
          setShow(data.membership?.status === "payment_failed");
        })
        .catch((err) => console.error("[PaymentFailedBanner] Failed to fetch membership:", err));
    };
    check();
    const onVisibility = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, [isSignedIn]);

  const handlePortal = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch("/api/stripe/portal", { method: "POST" });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setError("Portal konnte nicht geöffnet werden. Bitte versuche es erneut.");
      }
    } catch {
      setError("Verbindungsfehler. Bitte versuche es erneut.");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="bg-red-50 border-b border-red-100">
      <GridContainer grid={false} className="py-3 flex items-center gap-3">
        <AlertTriangle className="size-5 text-red-600 shrink-0" />
        <p className="text-copy-sm text-red-800 flex-1">
          {error ||
            "Zahlungsproblem — Deine letzte Zahlung konnte nicht verarbeitet werden."}
        </p>
        <button
          onClick={handlePortal}
          disabled={loading}
          className="text-copy-sm text-red-800 underline underline-offset-4 shrink-0"
        >
          {loading ? <Loader2 className="size-4 animate-spin" /> : "Zahlungsmethode aktualisieren"}
        </button>
      </GridContainer>
    </div>
  );
}
